import { matchesV4Product } from "./useV4Suggestions";

// Display identity only; V4 has no selection or publication action in the UI.
export const isV4ExplicitVector = suggestion =>
  suggestion?.decision_contract_version === "pricing-v4.live-pilot-product.v11";

export const v4LargestPortion = (
  suggestion,
  portions = suggestion?.portions
) => {
  if (!Array.isArray(portions) || !portions.length) return null;
  const ordered = [...portions].sort(
    (a, b) =>
      Number(b.portion_base) - Number(a.portion_base) ||
      Number(a.product_id) - Number(b.product_id)
  );
  const anchorId = suggestion.reference_anchor?.product_id;
  return anchorId == null
    ? ordered[0]
    : ordered.find(
        portion =>
          Number(portion.product_id) === Number(anchorId) &&
          Number(portion.portion_base) === Number(ordered[0].portion_base)
      ) || null;
};

const validPrice = value =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value)) &&
  Number(value) > 0;
export const canReviewV4Selection = (suggestion, id, catalogId) =>
  matchesV4Product(suggestion, id, catalogId) &&
  suggestion.status === "ready" &&
  suggestion.selection_allowed === true &&
  suggestion.stale !== true &&
  suggestion.catalog_baseline_changed !== true &&
  suggestion.stance !== "abstain" &&
  validPrice(suggestion.suggested_anchor_base_brl) &&
  Math.abs(
    Number(suggestion.suggested_anchor_base_brl) -
      Number(Number(suggestion.suggested_anchor_base_brl).toFixed(4))
  ) < 0.00000001 &&
  Boolean(suggestion.expires_at) &&
  new Date(suggestion.expires_at).getTime() > Date.now();

export function reconcileV4Distribution(
  calculation,
  suggestions,
  id,
  catalogIds,
  anchor
) {
  if (
    Number(calculation?.product_base_id) !== id ||
    calculation?.error ||
    calculation?.input_mode !== "price" ||
    !validPrice(calculation?.price_equivalente_calculado) ||
    Math.abs(Number(calculation.price_equivalente_calculado) - anchor) >
      0.0001 ||
    !Array.isArray(calculation.skus) ||
    !calculation.skus.length ||
    suggestions.length !== catalogIds.length
  )
    return false;
  const simulated = new Map();
  for (const sku of calculation.skus) {
    if (
      !sku.prod_sku ||
      !validPrice(sku.porcao) ||
      !validPrice(sku.preco_sugerido)
    )
      return false;
    const key = `${sku.prod_sku}:${Number(sku.porcao).toFixed(4)}`;
    if (simulated.has(key)) return false;
    simulated.set(key, Number(sku.preco_sugerido));
  }
  return suggestions.every((suggestion, index) => {
    if (
      !canReviewV4Selection(suggestion, id, catalogIds[index]) ||
      Math.abs(Number(suggestion.suggested_anchor_base_brl) - anchor) >
        0.0001 ||
      !Array.isArray(suggestion.portions) ||
      suggestion.portions.length !== simulated.size
    )
      return false;
    const seen = new Set();
    return suggestion.portions.every(portion => {
      if (
        !portion.sku ||
        !validPrice(portion.portion_base) ||
        !validPrice(portion.suggested_price_brl)
      )
        return false;
      const key = `${portion.sku}:${Number(portion.portion_base).toFixed(4)}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return (
        simulated.has(key) &&
        Math.abs(simulated.get(key) - Number(portion.suggested_price_brl)) <
          0.005
      );
    });
  });
}
